import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
export default function RacquetModal({ children }) {
  const [viewport, setViewport] = useState(null)
  useEffect(() => {
    const update = () => {
      const v = window.visualViewport
      setViewport({
        '--rp-sheet-top': `${(v?.offsetTop || 0) + 8}px`,
        '--rp-sheet-height': `${(v?.height || window.innerHeight) - 16}px`
      })
    }
    update()
    window.addEventListener('resize', update)
    window.visualViewport?.addEventListener('resize', update)
    window.visualViewport?.addEventListener('scroll', update)
    return () => {
      window.removeEventListener('resize', update)
      window.visualViewport?.removeEventListener('resize', update)
      window.visualViewport?.removeEventListener('scroll', update)
    }
  }, [])
  return createPortal(
    <div className="rp rp-overlay" style={viewport}>
      {children}
    </div>,
    document.body
  )
}
